







import Vue from 'vue'
import Component from 'vue-class-component'


@Component({
  components: {}
})
class ProductResourceItem2ProductStatistics extends Vue {

}

export default ProductResourceItem2ProductStatistics


